import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles/index';

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
    color: theme.palette.background.default,
    backgroundColor: '#4e91fd',
  },
});
class DeleteDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { handleClose, handleSubmit, classes, currentOrder} = this.props;
    return (
      <Dialog
        open
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Remove Tracking</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to remove this tracking number?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleSubmit(currentOrder.orderId, currentOrder.shipmentRef)} className={classes.button}>
            Delete
          </Button>
          <Button onClick={() => handleClose()} className={classes.button}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

DeleteDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  order: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};
export default withStyles(styles)(DeleteDialog);



// WEBPACK FOOTER //
// ./src/components/orders/DeleteDialog.js